import img1 from '../../assetsForWebsite/Gallery/gallery-1.jpg';
import img2 from '../../assetsForWebsite/Gallery/gallery-2.jpg';
import img3 from '../../assetsForWebsite/Gallery/gallery-3.jpg';
import img4 from '../../assetsForWebsite/Gallery/gallery-4.jpg';
import img5 from '../../assetsForWebsite/Gallery/gallery-5.jpg';
import img6 from '../../assetsForWebsite/Gallery/gallery-6.jpg';
import img7 from '../../assetsForWebsite/Gallery/gallery-7.jpg';
import img8 from '../../assetsForWebsite/Gallery/gallery-8.jpg';
import img9 from '../../assetsForWebsite/Gallery/gallery-9.jpg';
import footter from '../../assetsForWebsite/Gallery/footer.jpg';
export const data = [img1,img2,img3,img4,img5,img6,img7,img8,img9];
export const footer = footter;